import _ from 'lodash';

import { questionerAPI } from '../api/questioner';
import { actionWrapper } from './actionWrapper';
import { mealNames } from '../constants/questioner';

import { setLocalStorageObject, getLocalStorageObject } from '../utils/functions';

export const SET_MENUS = 'SET_MENUS';
export const SET_DISH = 'SET_DISH';
export const SET_MEALS_TO_CHANGE = 'SET_MEALS_TO_CHANGE';
export const SET_PROGRESS = 'SET_PROGRESS';

export const firstGenerateMenu = (callback) => actionWrapper(async () => {
  await questionerAPI.firstGenerateMenu();
  setLocalStorageObject('generatedMenu', null);
  callback?.();
});

export const getGeneratedMenu = () => actionWrapper(async (dispatch) => {

  const generatedMenus = await questionerAPI.getGenerateMenu();

  const originalMenus = getLocalStorageObject('generatedMenu');

  if (_.isEmpty(originalMenus)) {
    setLocalStorageObject('generatedMenu', generatedMenus);
  }

  dispatch({
    type: SET_MENUS,
    payload: generatedMenus,
  });
});

export const getDishDetails = (dishId) => actionWrapper(async (dispatch) => {
  const dishDetails = await questionerAPI.getDishDetails(dishId);
  dispatch({
    type: SET_DISH,
    payload: dishDetails,
  });
});

export const getMealsToChange = (day, meal) => actionWrapper(async (dispatch) => {
  const mealsToChange = await questionerAPI.getMealsToChange(day, meal);

  dispatch({
    type: SET_MEALS_TO_CHANGE,
    payload: mealsToChange,
  });
});

export const changeMeal = (data, callback) => actionWrapper(async (dispatch) => {
  await questionerAPI.changeMeal(data);
  dispatch(getGeneratedMenu());
  callback?.();
});

export const generateMenuContinue = (callback) => actionWrapper(async (dispatch, getState) => {
  const originalMenus = getLocalStorageObject('generatedMenu');
  const generatedMenus = getState().menus.menusData;

  const withChanges = originalMenus.find((dayMenus, dayIndex) => {
    return dayMenus.find((dish, dishIndex) => {
      return generatedMenus[dayIndex][dishIndex].id !== dish.id;
    });
  });

  if (!withChanges) {
    await questionerAPI.generateMenuContinue();
  }
  
  callback?.();
});

export const getProgress = () => actionWrapper(async (dispatch) => {
  const progress = await questionerAPI.getProgress();

  dispatch({
    type: SET_PROGRESS,
    payload: progress,
  });
}, null, true);

export const getBalancedMenu = () => actionWrapper(async (dispatch) => {
  const balancedMenu = await questionerAPI.getBalancedMenu();

  const groupedMenus = balancedMenu.map(menu => {
    return mealNames.map(meal => {
      const mealMenu = menu[meal];
      mealMenu.calories = mealMenu.nutrients.calories;
      mealMenu.meal_name = meal;
      return mealMenu;
    });
  });

  dispatch({
    type: SET_MENUS,
    payload: groupedMenus,
  });
});

export const getBalancedDishDetails = (dishId, day) => actionWrapper(async (dispatch) => {
  const dishDetails = await questionerAPI.getBalancedDishDetails(dishId, day);
  
  dispatch({
    type: SET_DISH,
    payload: dishDetails,
  });
});